exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-table thead th {\n  background: white;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  cursor: pointer;\n  border-top: none;\n}\n.fm-table thead th:hover {\n  background-color: #f8f9fa;\n}\n.fm-table thead th > i {\n  padding-left: 0.5rem;\n}\n.fm-table td {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.fm-table tr:hover {\n  background-color: #f8f9fa;\n}\n.fm-table .w-10 {\n  width: 10%;\n}\n.fm-table .w-65 {\n  width: 65%;\n}\n.fm-table .fm-content-item {\n  cursor: pointer;\n  max-width: 1px;\n}\n.fm-table .text-hidden {\n  color: #cdcdcd;\n}", ""]);

// exports
